import { Badge } from '@/components/ui/badge';
import { EOS_TODO_PRIORITY_LABELS, type EosTodoPriority } from '../types';

const VARIANT: Record<EosTodoPriority, 'default' | 'secondary' | 'outline' | 'destructive'> = {
  low: 'secondary',
  medium: 'default',
  high: 'destructive',
};

export function TodoPriorityBadge({ priority }: { priority: EosTodoPriority }) {
  return <Badge variant={VARIANT[priority]} className="text-xs">{EOS_TODO_PRIORITY_LABELS[priority]}</Badge>;
}
